import { getError } from '@autobid/strapi-integration/utils/getError'
import { useQuery } from '@tanstack/vue-query'
import { computed, onServerPrefetch } from 'vue'
import { decodeJwt } from '../utils/decodeJwt'
import { useAutobidAuth } from './useAutobidAuth'

export function useToken() {
  const { sessionData, isAuthed } = useAutobidAuth()
  const { $trpc } = useNuxtApp()
  const tokenData = computed(() => {
    const accessToken = sessionData.value?.accessToken

    return isAuthed.value && accessToken
      ? decodeJwt(accessToken.split(' ')[1])
      : null
  })
  const hash = computed(() => tokenData.value?.access.hash)

  const permissionsFn = async () => {
    if (!hash.value) {
      return null
    }

    try {
      return await $trpc.cerber.getPermissions.query({ hash: hash.value })
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        throw createError({ statusCode: code, statusMessage: message })
      }

      return null
    }
  }

  const { data: permissionsMap, suspense } = useQuery(
    ['permissions', hash],
    permissionsFn,
  )

  onServerPrefetch(suspense)

  return {
    tokenData,
    permissionsMap,
  }
}
